import { useTranslate } from 'react-admin'

import type { SpecialEventType } from '../../data'
import type { MarpolAnnex } from '../../data/source'

/** A MARPOL/BOMBEO's name: its annex when a MARPOL has one ("MARPOL I"), else its type. */
export const useEventName = () => {
  const translate = useTranslate()
  return ({ type, marpolAnnex }: { type: SpecialEventType; marpolAnnex: MarpolAnnex | null }): string =>
    type === 'MARPOL' && marpolAnnex !== null ? translate(`enums.MarpolAnnex.${marpolAnnex}`) : translate(`enums.ScaleEventType.${type}`)
}
